import { connect } from 'react-redux';
import { setSelectedResource } from '../../../../actions';
import geofences from 'APP_ROOT/data/geofences';
import GeofenceType from './Type';

const mapStateToProps = (state, ownProps) => {
    return {
        value: geofences.Selectors.geofenceType(state, ownProps.geofenceId, true),
        editingGeometry: geofences.Selectors.editingGeometry(state),
        status: geofences.Selectors.geofenceGeojsonChangePending(state, ownProps.geofenceId) ? 'PENDING' : ''
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChange: (geofenceType) => {
            dispatch(geofences.Actions.setGeofenceType(ownProps.stage, ownProps.geofenceId, geofenceType));
        },
        onConvert: (newGeojson) => {
            dispatch(geofences.Actions.convertGeofence(ownProps.stage, ownProps.geofenceId, newGeojson));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeofenceType);
